import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Button, { ButtonSize } from '@components/DesignSystem/Button'
import { useArticleContext } from '../_core'

type PreviewButtonProps = {
  className?: string
}

const PreviewButton = (props: PreviewButtonProps) => {
  const { className } = props
  const { t } = useTranslation('editor')
  const {
    previewDraftArticle,
    articleState: {
      publish: { warnings },
    },
  } = useArticleContext()

  useEffect(() => {
    if (warnings) {
      document.documentElement.scrollTop = 0
    }
  }, [warnings])

  return (
    <Button size={ButtonSize.block} onClick={previewDraftArticle} className={className}>
      {t('aside.preview')}
    </Button>
  )
}

export default PreviewButton
